import React from 'react'
import { FaBusinessTime, FaMapMarkerAlt } from 'react-icons/fa'
import PageTitle from '../hooks/PageTitle'
import Heading from '../layouts/Heading'
import PageHeader from '../layouts/PageHeader'

const Contact = () => {
  return (
      <>
        <PageTitle title="Contact"/>
        <PageHeader headerTitle="Contact"/>
        <div className="google-map-code">
          <iframe title="myFrame" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14553.998668563905!2d89.68781232833865!3d24.224296763544118!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39fde0a679b36229%3A0x6e7b507ebb0f163e!2sKhwaja%20Yunus%20Ali%20University!5e0!3m2!1sen!2sbd!4v1770800619575!5m2!1sen!2sbd" width="100%" height="450" frameBorder="0" style={{border:0}} allowFullScreen="" aria-hidden="false" tabIndex="1"></iframe>
        </div>
        <div className="container-xxl py-5">
            <div className="row">
            <div className="col-md-6">
              <Heading headingTitle="Our Office"/>
              <p data-aos="fade-up"><i className='me-3'> <FaMapMarkerAlt/></i>Mirpur, Dhaka, Bangladesh</p>
              <p data-aos="fade-up"><i className='me-3'><FaBusinessTime/></i>Sunday to Thursday 8.00 am- 5.00 pm</p>
            </div>
            <div className="col-md-6" data-aos="fade-up">
            <form>
              <div className="row g-3">
                <div className="col-md-6 pe-1">
                    <div className="form-floating">
                        <input type="text" className="form-control form-control-sm" id="name" placeholder="Your Name"/>
                        <label htmlFor="name">Your Name</label>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-floating">
                        <input type="email" className="form-control form-control-sm" id="email" placeholder="Your Email"/>
                        <label htmlFor="email">Your Email</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-floating">
                        <input type="text" className="form-control form-control-sm" id="subject" placeholder="Subject"/>
                        <label htmlFor="subject">Subject</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-floating">
                        <textarea className="form-control" placeholder="Leave a message here" id="message" style={{height: "100px"}}></textarea>
                        <label htmlFor="message">Message</label>
                    </div>
                </div>
                <div className="col-12">
                    <button className="btn btn-outline-success px-4" type="submit">Send Message</button>
                </div>
              </div>
            </form>
            </div>
            </div>
            <hr />
        </div>
      </>
  )
}

export default Contact